const DateNewest = (a, b) => {
    return -1 * (a.spin.dateCreatedInMilliseconds - b.spin.dateCreatedInMilliseconds);
}

export default DateNewest;